import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import get from 'lodash/get';
import { PartsDataRequestActionTypes, SearchtActionTypes } from '../models/parts-management';
const page_name = 'secretsManager';

export interface secretManagerState {
  isSecretManagementDataLoading: boolean;
  secretsData: Array<any>;
  secretManagerDataTotalRowCount: number;
  secretManagerDataPageNumber: number;
  secretManagerError: boolean;
  secretManagerLoading: boolean;
  isAddSecretSuccess: boolean;
  isAddSecretError: boolean;
  isUpdateSecretLoading: boolean;
  isUpdateSecretSuccess: boolean;
  isUpdateSecretError: boolean;
  isDeleteSecretLoading: boolean;
  isDeleteSecretSuccess: boolean;
  isDeleteSecretError: boolean;
  secretManagerMessage: string;

  templateData: Array<any>;
  secretTemplateDataTotalRowCount: number;
  secretTemplateDataPageNumber: number;
  secretTemplateError: boolean;
  secretTempalteLoading: boolean;
  isAddTemplateSuccess: boolean;
  isAddTemplateError: boolean;
  isUpdateTemplateLoading: boolean;
  isUpdateTemplateSuccess: boolean;
  isUpdateTemplateError: boolean;
  isDeleteTemplateLoading: boolean;
  isDeleteTemplateSuccess: boolean
  isDeleteTemplateError: boolean;
  secretStatusCode: number;
  searchItem: undefined | string;
  secretPageName: string;
  decryptedSecret: any;
  isFetchingSecretById: boolean;
}

const initialState: secretManagerState = {
  isSecretManagementDataLoading: false,
  secretsData: [],
  secretManagerDataTotalRowCount: 0,
  secretManagerDataPageNumber: 1,
  secretManagerError: false,
  secretManagerLoading: false,
  isAddSecretSuccess: false,
  isAddSecretError: false,
  isUpdateSecretLoading: false,
  isUpdateSecretSuccess: false,
  isUpdateSecretError: false,
  isDeleteSecretLoading: false,
  isDeleteSecretSuccess: false,
  isDeleteSecretError: false,
  secretManagerMessage: '',

  templateData: [],
  secretTemplateDataTotalRowCount: 0,
  secretTemplateDataPageNumber: 1,
  secretTemplateError: false,
  secretTempalteLoading: false,
  isAddTemplateSuccess: false,
  isAddTemplateError: false,
  isUpdateTemplateLoading: false,
  isUpdateTemplateSuccess: false,
  isUpdateTemplateError: false,
  isDeleteTemplateLoading: false,
  isDeleteTemplateSuccess: false,
  isDeleteTemplateError: false,

  secretStatusCode: 0,
  searchItem: '',
  secretPageName: 'Secret',

  decryptedSecret: {},
  isFetchingSecretById: false,
};

const secretManagerReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    fetchSecretByIdRequest: (state, action: any) => {
      state.isFetchingSecretById = true;
      state.isAddSecretSuccess = false;
      state.isUpdateSecretSuccess = false;
      state.isDeleteSecretSuccess = false;
    },
    fetchSecretByIdResponse: (state, action) => {
      state.isFetchingSecretById = false;
      state.decryptedSecret = get(action, 'payload.res', {});
    },
    fetchSecretByIdFailed: (state, action: any) => {
      state.isFetchingSecretById = false;
      state.secretManagerError = true;
      state.decryptedSecret = {};

      const message = getStatusMessage(page_name, action.payload);
      state.secretManagerMessage = message;
      // Snackbar.error(message.replace('Part', state.secretPageName));
    },
    getSecretsRequest: (state, action) => {
      state.isSecretManagementDataLoading = true;
      state.isAddSecretSuccess = false;
      state.isUpdateSecretSuccess = false;
      state.isDeleteSecretSuccess = false;
    },
    getSecretsResponse: (state, action) => {
      state.isSecretManagementDataLoading = false;
      // state.secretsData = get(action, 'payload.data', []);
      // state.secretManagerDataTotalRowCount = get(action, 'payload.total_count', []);
      // state.secretManagerDataPageNumber = get(action, 'payload.page', []);
      if (state.searchItem === get(action, 'payload.search_item', '')) {
        state.secretsData = get(action, 'payload.data', []);
        state.secretManagerDataTotalRowCount = get(action, 'payload.total_count', []);
        state.secretManagerDataPageNumber = get(action, 'payload.page', []);
      }
    },
    getSecretsFailed: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.secretManagerError = true;
      // state.secretsData = [];

      const message = getStatusMessage(page_name, action.payload);
      state.secretManagerMessage = message;
      // Snackbar.error(message.replace('Part', state.secretPageName));
    },
    addSecretRequest: (state) => {
      state.isSecretManagementDataLoading = true;
      state.isAddSecretSuccess = false;
      state.isAddSecretError = false;
    },
    addSecretResponse: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isAddSecretSuccess = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    addSecretFailed: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isAddSecretSuccess = false;
      state.isAddSecretError = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    updateSecretRequest: (state) => {
      state.isUpdateSecretLoading = true;
      state.isUpdateSecretSuccess = false;
      state.isUpdateSecretError = false;
    },
    updateSecretResponse: (state, action: any) => {
      state.isUpdateSecretLoading = false;
      state.isUpdateSecretSuccess = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    updateSecretFailed: (state, action: any) => {
      state.isUpdateSecretLoading = false;
      state.isUpdateSecretSuccess = false;
      state.isUpdateSecretError = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    deleteSecretRequest: (state) => {
      state.isSecretManagementDataLoading = true;
      state.isDeleteSecretLoading = true;
      state.isDeleteSecretSuccess = false;
      state.isDeleteSecretError = false;
    },
    deleteSecretResponse: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isDeleteSecretLoading = false;
      state.isDeleteSecretSuccess = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    deleteSecretFailed: (state, action) => {
      state.isSecretManagementDataLoading = false;
      state.isDeleteSecretLoading = false;
      state.isDeleteSecretSuccess = false;
      state.isDeleteSecretError = true;

      const message = getStatusMessage('secretsManager', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    getSecretTemplateRequest: (state) => {
      state.isSecretManagementDataLoading = true;
    },
    getSecretTemplateResponse: (state, action) => {
      state.isSecretManagementDataLoading = false;
      if (state.searchItem === get(action, 'payload.search_item', '')) {
        state.templateData = get(action, 'payload.data', []);
        state.secretTemplateDataTotalRowCount = get(action, 'payload.total_count', []);
        state.secretTemplateDataPageNumber = get(action, 'payload.page', []);
      }
    },
    getSecretTemplateFailed: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.secretTemplateError = true;
      state.templateData = [];
      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    addSecretTemplateRequest: (state) => {
      state.isSecretManagementDataLoading = true;
      state.isAddTemplateSuccess = false;
      state.isAddTemplateError = false;
    },
    addSecretTemplateResponse: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isAddTemplateSuccess = true;
      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    addSecretTemplateFailed: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isAddTemplateSuccess = false;
      state.isAddTemplateError = true;

      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    updateSecretTemplateRequest: (state) => {
      state.isUpdateTemplateLoading = true;
      state.isUpdateTemplateSuccess = false;
      state.isUpdateTemplateError = false;
    },
    updateSecretTemplateResponse: (state, action: any) => {
      state.isUpdateTemplateLoading = false;
      state.isUpdateTemplateSuccess = true;

      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    updateSecretTemplateFailed: (state, action: any) => {
      state.isUpdateTemplateLoading = false;
      state.isUpdateTemplateSuccess = false;
      state.isUpdateTemplateError = true;

      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    deleteSecretTemplateRequest: (state) => {
      state.isSecretManagementDataLoading = true;
      state.isDeleteTemplateLoading = true;
      state.isDeleteTemplateSuccess = false;
      state.isDeleteTemplateError = false;
    },
    deleteSecretTemplateResponse: (state, action: any) => {
      state.isSecretManagementDataLoading = false;
      state.isDeleteTemplateLoading = false;
      state.isDeleteTemplateSuccess = true;

      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.success(message);
    },
    deleteSecretTemplateFailed: (state, action) => {
      state.isSecretManagementDataLoading = false;
      state.isDeleteTemplateLoading = false;
      state.isDeleteTemplateSuccess = false;
      state.isDeleteTemplateError = true;

      const message = getStatusMessage('secretsManagerTemplate', action.payload);
      state.secretManagerMessage = message;
      Snackbar.error(message);
    },
    resetReadSecret : (state)=>{
      state.isSecretManagementDataLoading = false;
      state.secretManagerError = true;
      state.decryptedSecret = {};
      state.secretManagerMessage = '';
    },
    resetData: (state) => {
      state.secretManagerError = false;
      state.secretManagerLoading = false;
      state.isAddSecretSuccess = false;
      state.isAddSecretError = false;
      state.isUpdateSecretLoading = false;
      state.isUpdateSecretSuccess = false;
      state.isUpdateSecretError = false;
      state.isDeleteSecretLoading = false;
      state.isDeleteSecretSuccess = false;
      state.isDeleteSecretError = false;
      state.isDeleteTemplateError = false;
      state.secretTemplateError = false;
      state.secretTempalteLoading = false;
      state.isAddTemplateSuccess = false;
      state.isAddTemplateError = false;
      state.isUpdateTemplateLoading = false;
      state.isUpdateTemplateSuccess = false;
      state.isUpdateTemplateError = false;
      state.isDeleteTemplateLoading = false;
      state.isDeleteTemplateSuccess = false;
    },
    onSearchForItem: (state, action: SearchtActionTypes) => {
      state.searchItem = action.payload;
    },
  },
});

export const secretManagerActions = secretManagerReducer.actions;
export default secretManagerReducer;
